<div [attr.aria-label]="getAriaTitleText()" class="ap-stepper-header__steps" role="tablist">
    @for (stepVisited of visitStates; track i; let i = $index; let first = $first) {
        @if (!first) {
            <span class="horizontal-line" [ngClass]="{ pristine: !hasVisited(i) }">
                @if (!first) {
                    <span class="horizontal-progress-line" [style.width.%]="stepProgress()"></span>
                }
            </span>
        }
        <button
            role="tab"
            data-testid="stepper-header-step"
            [id]="uniqueId() + '-ap-stepper-' + (i + 1)"
            class="ap-stepper-header__step ap-stepper-header__dot"
            [ngClass]="{
                navigatable: hasVisited(i) && navigationEmitter,
                visited: hasVisited(i),
                'ap-stepper-header__dot': activatedIndex !== i,
                'ap-stepper-header__identifier': activatedIndex === i
            }"
            [attr.disabled]="!(hasVisited(i) && navigationEmitter) && activatedIndex !== i ? 'true' : null"
            [attr.aria-label]="'stap' + (i + 1)"
            [attr.aria-current]="activatedIndex === i ? 'step' : null"
            [attr.aria-controls]="hasVisited(i) ? uniqueId() + (i + 1) : null"
            (click)="click(i)"
            (keydown)="onKeyDown($event)"
        >
            @if (activatedIndex === i) {
                <span class="ap-stepper-header__identifier-number">{{ activatedIndex + 1 }}</span>
            }
        </button>
    }
</div>
